  <div
    class="clearfix py-3 position-relative border-bottom last-item-border">
    <img
      class="rounded user-40 post-pic rounded-circle float-left mr-3"
      src="{{ speakerObj?.profile_pic }}"
      onerror="this.src='assets/themes/icons/user-profile-placeholder.svg'"/>
    
    <div class="d-flex align-items-center justify-content-between">
      <div>
      <p class="paragraph-bold">
        {{ speakerObj?.name }}
        <span *ngIf="speakerObj?.role != '' && speakerObj?.role != undefined "  class="chip small outline ml-2">{{speakerObj?.role}}</span>
      </p>

      <span class="secondary-paragraph">
        <span class="color-grey-500">{{ speakerObj?.qualification }}</span>
        {{ speakerObj?.speciality_name }}
      </span>

      <span *ngIf="speakerObj?.slots != undefined">
        <p class="secondary-paragraph mb-1">
         <span class="color-grey-500">{{ speakerObj?.slots[0]?.topic_name }}</span>
        </p>
        <p class="secondary-paragraph">
         <span class="color-grey-500">{{ speakerObj?.slots[0]?.start_time }}</span>
          <span *ngIf="speakerObj?.slots[0] != null">-</span>
          <span class="color-grey-500">{{ speakerObj?.slots[0]?.end_time }}</span>
        </p>
      </span>
    </div>
    <button class="btn-design small outline h-auto">{{mls.languageText.survey_detail.key15}}</button>
    </div>
    
  </div>